<div class="container-fluid p-0 m-0">
  <div class="card border-0 p-0 m-0">
    <div class="card-header">
      TRANSFER TO CASINO WALLET
    </div>
    <div class="card-body">
      <form [formGroup]="depositForm">
        <div class="container">
          <p
            *ngIf="errorMsg"
            class="alert alert-danger m-1 p-1"
          >
            {{ errorMsg }}
          </p>
          <div class="form-group">
            <h5>Wallet Balance: ₹{{displayBalance | number : '.2-2'}}</h5>
          </div>
          <div class="form-group">
            <label for="inputName">Amount</label>
            <input type="number" formControlName="amount" class="form-control" id="inputName"
                   placeholder="Enter amount">
            <span
              class="text-danger"
              *ngIf="
                depositFormControl.amount.touched &&
                depositFormControl.amount.errors?.required">
              Amount is required
            </span>
            <span class="text-danger" *ngIf="depositForm.get('amount').hasError('min')">
              Amount must be greater than 0.
            </span>
            <span class="text-danger" *ngIf="depositForm.get('amount').hasError('max')">
              Amount must be less than main balance.
            </span>
          </div>

          <div class="text-left">
            <button class="btn btn-danger" (click)="dismiss()">CANCEL</button>
            <button class="btn btn-success ml-2" (click)="addDepositRequest()">SUBMIT</button>
          </div>
          <!--        <div class="container" style="text-align:center;"><a style="color:yellow;">Forgot password?</a></div>-->
          <!--        <div class="text-center" style="margin: -3.5%;">-->
          <!--          <button class="btn rounded-pill button_new " (click)="register()">Register</button>-->
          <!--        </div>-->
        </div>
      </form>
    </div>
  </div>
  <!--  <div class="d-flex justify-content-between">-->
  <!--    <h3 class="text-warning">Bet Slip</h3>-->
  <!--    <span (click)="closeDialog()" class="material-symbols-outlined">close</span>-->
  <!--  </div>-->
</div>
